// OWNER: AREA-TEMPLATES
// Section layout: supplies the "Partials" breadcrumb for every page under /partials.
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/partials')({
  staticData: { crumb: 'Partials' },
  component: Outlet,
})
